// src/app/not-found.tsx

'use client';
import { Button } from './_components/Button';
import { Gutter } from './_components/Gutter';
import { VerticalPadding } from './_components/VerticalPadding';
import Image from 'next/image';
// import error400cover from '../../../img/theme/error400cover.jpeg'

export default function NotFound(): JSX.Element {
  return (
    <Gutter>
      <div className="auth-page-content">
        <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
          <div className="auth-page-content overflow-hidden p-0" style={{ maxWidth: 600, width: '100%' }}>
            <VerticalPadding bottom="none" top="medium">
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ flex: '0 0 100%' }}>
                  <div className="text-center">
                    <Image
                      src="/img/theme/error400cover.jpg"
                      alt="Error 400 Cover"
                      width={500}
                      height={300}
                      className="img-fluid"
                     
                    />
                    <div className="mt-3">
                      {/* <h3 className="text-uppercase">Sorry, Page not Found !!</h3> */}
                      <p className="text-muted mb-4">The page you are looking for is not available!</p>
                      <Button href="/"  appearance="primary" label="Back to Home"/>
                    
                    </div>
                  </div>
                </div>
              </div>
            </VerticalPadding>
          </div>
        </div>
      </div>
    </Gutter>
  );
}
